module.exports = __webpack_public_path__ + "img/mongodb.b1847af9.svg";